import { useTranslation } from 'react-i18next';
import { Box, Card, Typography } from '@mui/material';
import { Blueprint } from 'types';
import { ProjectPartnerLogo } from './ProjectPartnerLogo';

interface ProjectPartnersBoxProps {
  blueprintDetails: Blueprint;
}

export const ProjectPartnersBox = ({ blueprintDetails }: ProjectPartnersBoxProps) => {
  const { t } = useTranslation();

  if (!blueprintDetails) {
    return null;
  }

  return (
    <Card sx={{ padding: 4, borderRadius: '8px' }}>
      <Typography variant="h3">{t('blueprints:details.projectPartners.title')}</Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 3,
          flexWrap: 'wrap',
          mt: 3,
        }}
      >
        <ProjectPartnerLogo blueprintDetails={blueprintDetails} />
      </Box>
    </Card>
  );
};
